import { CustomFile } from '../../FormUploadFile.interfaces';
import {
    Box,
    Grid,
    Icon,
    IconButton,
    Typography,
    useTheme,
} from '../../../../base-components';
import { fileData } from '../../utils';

interface Props {
    file: CustomFile;
    onDelete: () => void | undefined;
}

const SingleFilePreview = (props: Props) => {
    const { file, onDelete } = props;
    const { name = '' } = fileData(file);
    const theme = useTheme();
    if (!file) {
        return null;
    }

    return (
        <Grid
            container
            justifyContent={'space-between'}
            pt={1}
            sx={{ borderBottom: `1px solid ${theme.palette.primary.light}` }}
        >
            <Grid item alignItems="center" display={'flex'} gap={1}>
                <Icon
                    name={'PaperFilledIcon'}
                    color={theme.palette.primary.main}
                />
                <Typography variant={'subtitle1'}>{name}</Typography>
            </Grid>
            <Grid item>
                <IconButton onClick={onDelete} size="small">
                    <Icon name={'TrashIcon'} />
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default SingleFilePreview;
